<template>
	<scroll-view 
	scroll-y
	@touchstart="handleTouchStart"
	@touchend="handleTouchEnd"
	class="slide_box">
		<slot></slot>
	</scroll-view>
</template>

<script>
	export default{
		data(){
			return {
				touchStart:{}
			}
		},
		methods:{
			/**
			 * 触摸开始 **/
			handleTouchStart(e) {
				this.touchStart = e.touches[0];
			},
			// 触摸结束
			handleTouchEnd(e){
				let deltaX = e.changedTouches[0].clientX - this.touchStart.clientX;
				let deltaY = e.changedTouches[0].clientY - this.touchStart.clientY;
				if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
					if (deltaX >= 0) {
						this.$emit('setPre')
					} else {
						this.$emit('setNext')
					}
				} else if (Math.abs(deltaY) > 50 && Math.abs(deltaX) < Math.abs(deltaY)) {
					if (deltaY < 0) {
						// console.log("上滑")
					} else {
						// console.log("下滑")
					}
				} else {
					// console.log("可能是误触！")
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.slide_box{
		height: 100%;
	}
</style>
